module.exports = __webpack_public_path__ + "static/media/WhatIsCulture_2.603216a5.png";